import { render } from "./SideBarInstaller.vue?vue&type=template&id=1407fa75&scoped=true"
import script from "./SideBarInstaller.vue?vue&type=script&lang=js"
export * from "./SideBarInstaller.vue?vue&type=script&lang=js"

import "./SideBarInstaller.vue?vue&type=style&index=0&id=1407fa75&scoped=true&lang=css"

import exportComponent from "/home/clients/74415e597e89acaa30448f5e983fc289/sites/poses.renosolu.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1407fa75"]])

export default __exports__